import { placeholders } from '..';
export { DzPhoneInputView as DzPhoneInput } from './dz-phone-input.view';
export const DEFAULT_VALID_ERROR = `Please enter a valid phone number. Valid formats: ${placeholders.phone}.`;
